import type { ReactNode } from "react";

export interface AspectRatioProps {
  children?: ReactNode;
  ratio?: number;
}

export function AspectRatio({ children, ratio }: AspectRatioProps) {
  const style = ratio ? { paddingBottom: `${(1 / ratio) * 100}%` } : {};

  return (
    <div className="lookbook--aspect-ratio--outer-wrapper" style={style}>
      <div className="lookbook--aspect-ratio--inner-wrapper">{children}</div>
    </div>
  );
}
